<template>
    <AdminLayout>
        <div class="table-container p-4">
            <div class="rows-header">
                Rows: {{ searchResult.totalRows ?? 0 }}
            </div>
            <form @submit.prevent="search" class="h-100">
                <div class="table-section">
                    <table class="table table-hover table-sm align-middle">
                        <thead style="position: sticky; top: 0; z-index: 10;">
                            <tr>
                                <th>Client</th>
                                <th>Action By</th>
                                <th>Action Type</th>
                                <th>Payload</th>
                                <th>Date</th>
                            </tr>
                            <tr>
                                <th>
                                    <input type="text" class="form-control" v-model="searchModel.fullname_client" />
                                </th>
                                <th>
                                    <input type="text" class="form-control" v-model="searchModel.fullname_user" />
                                </th>
                                <th>
                                    <input type="text" class="form-control" v-model="searchModel.type_ual" />
                                </th>
                                <th>
                                    <input type="text" class="form-control" v-model="searchModel.payload_ual" />
                                </th>
                                <th>
                                    <input type="text" class="form-control" v-model="searchModel.addeddate_ual" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="isSearching">
                                <TableSkeleton :columns="12" />
                            </template>
                            <template v-else-if="searchResult?.logs?.length === 0">
                                <EmptyTable :colspan="12" />
                            </template>
                            <template v-else>
                                <tr v-for="log in searchResult.logs" :key="log.syspk_ual">
                                    <td>{{ log.fullname_client }}</td>
                                    <td>{{ log.fullname_user }}</td>
                                    <td>{{ log.type_ual }}</td>
                                    <td style="max-width: 200px; word-wrap: break-word; white-space: normal;">
                                        {{ log.payload_ual }}
                                    </td>
                                    <td>{{ log.addeddate_ual }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <button type="submit" class="d-none">Submit</button>
            </form>
        </div>

    </AdminLayout>
</template>
<script setup>
import EmptyTable from '@/components/animations/EmptyTable.vue';
import TableSkeleton from '@/components/animations/TableSkeleton.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import logService from '@/services/logService';
import { onMounted, ref } from 'vue';
const searchModel = ref({});
const searchResult = ref({});
const isSearching = ref(false);
const search = async () => {
    isSearching.value = true;
    searchResult.value = await logService.search(searchModel.value);
    isSearching.value = false;
}

onMounted(() => {
    search();
})
</script>

<style scoped>
.table-section {
    background: white;
    border-radius: 16px;
    overflow: auto;
    box-shadow: 0 5px 25px rgba(220, 53, 69, 0.08);
    border: 1px solid rgba(220, 53, 69, 0.05);
    max-height: 85vh;
}


/* Container for the entire section */
.table-container {
    position: relative;
    height: 100vh;
    /* or whatever height you want */
    display: flex;
    flex-direction: column;
}

/* Freeze the Rows div */
.rows-header {
    position: sticky;
    top: 0;
    background: white;
    /* or your background color */
    z-index: 100;
    padding: 10px 0;
    border-bottom: 1px solid #dee2e6;
}

/* Make the table responsive container scrollable */
.table-responsive {
    flex: 1;
    overflow-y: auto;
    overflow-x: auto;
    position: relative;
}

/* Freeze the thead */
.table thead {
    position: sticky;
    top: 0;
    z-index: 50;
    background: white;
    /* or your background color */
}

.table thead th {
    background: white;
    /* or your background color */
    border-bottom: 2px solid #dee2e6;
}

/* If you want both rows of thead to stay */
.table thead tr {
    background: white;
    /* or your background color */
}

/* For the second thead row (filter inputs) */
.table thead tr:last-child th {
    background: white;
    /* or your background color */
    border-bottom: 1px solid #dee2e6;
}
</style>